// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Dashboard from "./components/dashboard";
import PortfolioPage from "./components/PortfolioPage";
import Aboutus from "./components/aboutus";
import Contactus from "./components/contactus";



const App = () => {
  return (
    <Router>
      <Routes>

        <Route path="/" element={<Dashboard />} />
        <Route path="/:id" caseSensitive={false} element={<PortfolioPage />} />
        <Route path="/aboutus" caseSensitive={false} element={<Aboutus />} />
        <Route path="/contactus" caseSensitive={false} element={<Contactus />} />

      </Routes>
    </Router>
  );
};

export default App;
